"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = ({ measurementPhotos, mainPhotoKey, onChangeMainPhotoKey }) => {
    const [loadedImage, setLoadedImage] = (0, react_1.useState)(0);
    const incLoadedImage = () => setLoadedImage(loadedImage + 1);
    if (!measurementPhotos)
        return null;
    return ((0, jsx_runtime_1.jsxs)(Container, { loadedImage: loadedImage, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("img", { src: measurementPhotos[mainPhotoKey], alt: mainPhotoKey, onLoad: incLoadedImage }, mainPhotoKey) }, void 0), (0, jsx_runtime_1.jsx)("div", { children: Object.entries(measurementPhotos).map(([key, value]) => ((0, jsx_runtime_1.jsx)("div", { onClick: () => onChangeMainPhotoKey(key), children: (0, jsx_runtime_1.jsx)("img", { src: value, alt: key, onLoad: incLoadedImage, "data-border": mainPhotoKey === key }, key) }, key))) }, void 0)] }, void 0));
};
const Container = styled_components_1.default.div `
  flex: 1;
  display: flex;
  flex-direction: column;

  & > div:first-of-type {
    display: flex;
    height: auto;
    width: 100%;
  }

  & > div:last-of-type {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    margin-top: ${({ theme }) => theme.spacings.m};
  }

  & > div:last-of-type > div {
    flex: 1;
  }

  & > div:last-of-type > div:not(:last-of-type) {
    margin-right: ${({ theme }) => theme.spacings.m};
  }

  img {
    height: auto;
    width: 100%;
    object-fit: contain;
    align-self: flex-start;
    display: ${({ loadedImage }) => loadedImage > 3 ? "block" : "none"};
  }

  img[data-border="true"] {
    border: 1px solid ${({ theme }) => theme.colors.greyBase};
  }
`;
//# sourceMappingURL=Images.js.map